import React from "react";

import SwiperCore, { Pagination } from "swiper";
import { SwiperSlide } from "swiper/react";

import { Container } from "@bared/ui";

import { InstagramCard, type InstagramCardProps } from "./InstagramCard";

import { clsx } from "clsx";

import Swiper from "@components/Swiper/Swiper";

SwiperCore.use([Pagination]);

const StyledSwiper = (props: any) => (
  <Swiper
    {...props}
    className={clsx(props.className, "[&_.swiper-initialized]:pb-mega")}
  />
);

export interface InstagramProps {
  posts: ({ _id: string } & InstagramCardProps)[];
}

export function Instagram({ posts }: InstagramProps) {
  if (0 === posts.length) return null;

  return (
    <Container flush={true}>
      <StyledSwiper
        pagination={{ clickable: true }}
        slidesPerView={2.5}
        preloadImages={false}
        observer={true}
        observeParents={true}
        breakpoints={{
          1024: {
            observer: true,
            observeParents: true,
            slidesPerView: 3.5,
          },
          1281: {
            observer: true,
            observeParents: true,
            slidesPerView: 4.5,
          },
        }}
      >
        {posts.map((post) => (
          <SwiperSlide key={post._id}>
            <InstagramCard {...post} />
          </SwiperSlide>
        ))}
      </StyledSwiper>
    </Container>
  );
}
